module.exports = { "default": require("core-js/library/fn/math/sign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/sign.js
// module id = 746
// module chunks = 0